<div id="activities" class="activities-specific-css">
    @if (!loadingEnterprises) {
      <app-activities-header />
      <div class="mt-2">
        <router-outlet />
      </div>
    } @else {
      <div class="">
        <p-skeleton width="100%" height="50px" styleClass="mt-3 mb-3" />
        <p-skeleton width="100%" height="90vh" styleClass=" mb-4" />
      </div>
    }
</div>
